import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-loading",
  "use": "icon-s-loading-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-loading\"><path d=\"M11 1v2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8H1c0 5.523 4.477 10 10 10s10-4.477 10-10S16.523 1 11 1\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol